import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id as IdSchema } from '@sigma/common/schema/Id.js';
export const SubscriptionGetDetailsEndpointParams = z.object({
    subscriptionId: IdSchema,
});
/**
 * Endpoint to retrieve subscription details (product name, price) for display in the UI.
 */
export const SubscriptionGetDetailsEndpoint = defineEndpoint({
    name: 'SubscriptionGetDetails',
    input: SubscriptionGetDetailsEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=SubscriptionGetDetailsEndpoint.js.map